export type LiveSessionState =
  | 'disconnected'
  | 'connecting'
  | 'active'
  | 'recovering'
  | 'terminated';

const allowedTransitions: Record<LiveSessionState, LiveSessionState[]> = {
  disconnected: ['connecting'],
  connecting: ['active', 'disconnected', 'terminated'],
  active: ['recovering', 'disconnected', 'terminated'],
  recovering: ['active', 'disconnected', 'terminated'],
  terminated: [],
};

export const canTransitionState = (
  current: LiveSessionState,
  next: LiveSessionState,
): boolean => allowedTransitions[current].includes(next);

export const assertStateTransition = (
  current: LiveSessionState,
  next: LiveSessionState,
): void => {
  if (!canTransitionState(current, next)) {
    throw new Error(`Invalid live session transition: ${current} -> ${next}`);
  }
};
